import styled from "styled-components";

const CreativeContainer = styled.div`
  .SubTitle {
    text-align: left;
    margin-bottom: 1%;
  }
  .SpecialText {
    color: rgb(23, 171, 193);
    font-size: 1.2rem;
    margin-left: 1%;
  }
`;
export default CreativeContainer;
